// extracted by mini-css-extract-plugin
export default {"themeInput":"ToggleThemeInput_themeInput__zdjmF","themeInput__label":"ToggleThemeInput_themeInput__label__8CUu4"};